/**
 * @param {*} value
 * @returns
 */
export const IsNumber = (value) => typeof value === 'number';

/**
 * @param {*} value
 * @returns
 */
export const IsString = (value) => typeof value === 'string';
